import { useEffect, useState } from "react";

import { useMainPageState } from "../../../../../store/selectors";

import { Container } from "../../../../../components";
import { Differences } from "./components/Differences/Differences";
import { Form } from "./components/Form/Form";
import { PopularQueries } from "./components/PopularQueries/PopularQueries";
import { Title } from "./components/Title/Title";

import { ContentBox, Wrapper, WrapperRoot } from "./HeroModule.styled";

export const HeroModule = () => {
  const [url, setUrl] = useState("");
  const [showPopularQueries, setShowPopularQueries] = useState(false);

  const { mainPageData } = useMainPageState();

  useEffect(() => {
    if (mainPageData?.popularUrls?.length > 0) {
      setShowPopularQueries(true);
    }
  }, [mainPageData?.popularUrls?.length]);

  return (
    <WrapperRoot isPopularQueries={showPopularQueries}>
      <Container isBig={true}>
        <Wrapper isPopularQueries={showPopularQueries}>
          <ContentBox>
            <Title />
            <Differences />
            <Form url={url} />
          </ContentBox>

          {showPopularQueries && (
            <PopularQueries setUrl={setUrl} mainPageData={mainPageData} />
          )}
        </Wrapper>
      </Container>
    </WrapperRoot>
  );
};
